import React, { useState } from "react";
import "./index.css";
import ImageMapper from "./ImageMapper";
import LocationSelector from "./LocationSelector";

const BeaconMapper = () => {
  const [selectedFloorId, setSelectedFloorId] = useState("");

  const handleFloorSelection = (floorId) => {
    setSelectedFloorId(floorId);
  };

  return (
    <div className="beacon-mapper-container">
      <header className="beacon-mapper-header">
        <h2>Beacon Mapper</h2>
      </header>
      <main className="beacon-mapper-main">
        <div className="beacon-mapper-card">
          <LocationSelector onFloorSelect={handleFloorSelection} />

          <ImageMapper selectedFloorId={selectedFloorId} />
        </div>
      </main>
    
    </div>
  );
};

export default BeaconMapper;
